import React from 'react';

import { ContactDetails } from '@components/utilities/Contact/ContactDetails';

export const ShipperDetails: React.FC = () => <ContactDetails type="shipper" />;
